var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.923,
    height: 14,
    viewBox: "0 0 12.923 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/timer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.173 7.673a4.714 4.714 0 0 1 -4.711 4.712A4.714 4.714 0 0 1 1.75 7.673a4.714 4.714 0 0 1 4.712 -4.711A4.714 4.714 0 0 1 11.174 7.674",
    stroke: "#1D2023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.0769166666666667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.462 4.846v2.692",
    stroke: "#1D2023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.0769166666666667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.846 1.615H8.076",
    stroke: "#1D2023",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.0769166666666667
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timer-icon.cfff4948be794d2987b01fc4d775392d.svg";
export { ForwardRef as ReactComponent };